import { render, staticRenderFns } from "./ShoppingBagLogoWhite.vue?vue&type=template&id=22330c30&scoped=true&"
var script = {}
import style0 from "./ShoppingBagLogoWhite.vue?vue&type=style&index=0&id=22330c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22330c30",
  null
  
)

export default component.exports